import { removeServerCookies } from "@/lib/cookies";
import { useUserOrganizationStore } from "@/store/useUserOrganizationStore";
import { useUserStore } from "@/store/useUserStore";

// Limpa a sessão local na hora e revoga a sessão no backend. A promise resolve quando
// a revogação termina (com ou sem sucesso): quem precisa garantir a revogação antes de
// navegar (logout manual) aguarda; os demais chamadores podem ignorá-la.
export function clearSession(): Promise<void> {
  removeServerCookies();
  useUserStore.getState().reset();
  useUserOrganizationStore.getState().resetAll();
  // remove os dados persistidos no localStorage, não só os valores em memória
  useUserStore.persist.clearStorage();
  useUserOrganizationStore.persist.clearStorage();

  // o refresh token fica em cookie httpOnly: só o BFF consegue revogá-lo e removê-lo
  if (typeof window === "undefined") return Promise.resolve();

  return fetch("/api/logout", { method: "POST", keepalive: true })
    .then(() => undefined)
    .catch(() => undefined);
}
